import React from 'react'
import { INPUT_FORM_COMMON_SIZE } from '../genericComponents/OverlayWrapper'

type WizardWrapperType = {
  children: React.ReactNode
}
export const WizardWrapper: React.FC<WizardWrapperType> = ({ children }: WizardWrapperType) => {
  return (
    <div className={'overflow-auto ' + INPUT_FORM_COMMON_SIZE}>
      <div className="overflow-auto">
        <div className="flex flex-col p-3 md:p-10 bg-white mx-auto">{children}</div>
      </div>
    </div>
  )
}
